import classnames from 'classnames';
import { bool, oneOf } from 'prop-types';
import React from 'react';

import { publicStatuses, STATUS_COLOR_MAP } from '../../campaigns/constants';

export default function CampaignStatus({ status, small }) {
  const color = STATUS_COLOR_MAP[status];
  const colorClass = `border-${color} text-${color}`;
  const pxClass = `px-${small ? 1 : 2}`;
  const pyClass = `py-${small ? 0 : 1}`;
  const smallClass = small ? 'small' : '';

  return (
    <h6
      className={classnames(
        'm-0 border-2 rounded-pill',
        colorClass,
        pxClass,
        pyClass,
        smallClass,
      )}
    >
      {status}
    </h6>
  );
}

CampaignStatus.propTypes = {
  status: oneOf(publicStatuses.map(s => s.value)).isRequired,
  small: bool,
};

CampaignStatus.defaultProps = {
  small: false,
};
